export default __webpack_public_path__ + "static/media/Fifth.625f5540.png";